export function createStageRecommendations(CATALOG) {
const normalize = (text) => String(text || '')
    .trim()
    .toLowerCase()
    .replace(/[\s？?。，,!！]/g, '');

const byIndex = new Map(CATALOG.questions.map((item) => [item.index, item]));

const questionKeyToModule = new Map();
CATALOG.questions.forEach(item => {
    questionKeyToModule.set(normalize(item.question), CATALOG.modules.findIndex(m => m.id === item.moduleId));
});

const userContents = (history) => (history || [])
    .filter((message) => String(message?.role || '').toLowerCase() === 'user')
    .map((message) => String(message?.content || ''));

const inferModuleIndex = (history) => {
    const contents = userContents(history);
    for (let i = contents.length - 1; i >= 0; i -= 1) {
        const key = normalize(contents[i]);
        if (!key) continue;
        if (questionKeyToModule.has(key)) return questionKeyToModule.get(key);
        for (const [question, moduleIndex] of questionKeyToModule.entries()) {
            if (question.length >= 8 && key.includes(question)) return moduleIndex;
        }
    }
    return null;
};

const askedKeys = (history) => new Set(userContents(history).map(normalize).filter(Boolean));

const pickFromModule = (moduleIndex, asked, used) => {
    const module = CATALOG.modules[moduleIndex];
    if (!module) return null;
    for (const index of module.questions) {
        if (used.has(index)) continue;
        const item = byIndex.get(index);
        if (!item || asked.has(normalize(item.question))) continue;
        return item;
    }
    return null;
};

const getQuestion = (question) => {
    const item = byIndex.get(question?.index);
    // 同时校验题号和题目，禁止旧题库或错位的索引静默返回另一题答案。
    return item && normalize(item.question) === normalize(question?.question) ? item : null;
};

const getQuestions = (history, limit = 3, selectedIndex = null) => {
    if (limit <= 0) return [];
    const asked = askedKeys(history);
    const selected = byIndex.get(selectedIndex);
    const current = selected ? CATALOG.modules.findIndex(m => m.id === selected.moduleId) : inferModuleIndex(history);
    if (selected) asked.add(normalize(selected.question));
    if (current == null) {
        return CATALOG.initialIndices
            .map((index) => byIndex.get(index))
            .filter(Boolean)
            .slice(0, limit);
    }
    const last = CATALOG.modules.length - 1;
    const slots = [
        Math.min(current + 1, last),
        Math.min(current + 1, last),
        current,
    ];
    const chosen = [];
    const used = new Set();
    for (const moduleIndex of slots) {
        const item = pickFromModule(moduleIndex, asked, used);
        if (!item) continue;
        chosen.push(item);
        used.add(item.index);
        if (chosen.length >= limit) return chosen;
    }
    for (let moduleIndex = CATALOG.forwardOnly ? current : 0; moduleIndex < CATALOG.modules.length; moduleIndex += 1) {
        let item = pickFromModule(moduleIndex, asked, used);
        while (item && chosen.length < limit) {
            chosen.push(item); used.add(item.index);
            if (!CATALOG.forwardOnly) break;
            item = pickFromModule(moduleIndex, asked, used);
        }
        if (chosen.length >= limit) break;
    }
    return chosen;
};



// 自由问答保留模型排序；旧服务、无效返回或请求失败时从完整题库补齐。
const completeFreeText = (result, history, limit = 3) => {
    if (limit <= 0) return [];
    const asked = askedKeys(history);
    const used = new Set();
    const chosen = [];
    const candidates = [
        ...(Array.isArray(result) ? result.map(getQuestion).filter(Boolean) : []),
        ...CATALOG.questions,
    ];
    for (const item of candidates) {
        if (used.has(item.index) || asked.has(normalize(item.question))) continue;
        used.add(item.index);
        chosen.push(item);
        if (chosen.length >= limit) break;
    }
    return chosen;
};

return {getQuestion, getQuestions, completeFreeText};
}
